import { FC, ReactNode, useEffect } from 'react';
import useAuth from '@/hooks/useAuth';
import { authStore } from '../../store/auth';
import { useRecoilState } from 'recoil';
import { sendSetUserEvent } from 'lib/gtm';

type Props = {
  children: ReactNode;
};

/**
 * 画面遷移時に1度だけ認証処理を走らせる
 * 認証状態に応じたアクセス制御・リダイレクト等はPrivatePageコンポーネントや各getServerSideProps等で行う
 */
export const AuthProvider: FC<Props> = ({ children }) => {
  const { signIn } = useAuth();
  const [auth] = useRecoilState(authStore);

  useEffect(() => {
    signIn();
  }, []);

  // set userId to GA4 via GTM
  // FIXME: セッションスタートした時だけ、ユーザーID設定の処理をしたい
  useEffect(() => {
    if (auth.status === 'authenticated') {
      sendSetUserEvent(auth.user?.uid as string);
    }
  }, [auth]);

  return <>{children}</>;
};
